export default "__VITE_ASSET__f1543096__"